// Chakra imports
import { Box, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import standaloneRoutes from 'standaloneRoutes';

// Standalone Meeting Layout - Fullscreen experience without navigation
export default function StandaloneLayout(props) {
  const { ...rest } = props;
  const routes = standaloneRoutes;
  const location = useLocation();

  const getRoute = () => {
    return location.pathname.includes('/meetings/');
  };

  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/meetings') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      return null;
    });
  };

  const bg = useColorModeValue('gray.50', 'gray.900');

  return (
    <Box bg={bg} minH="100vh">
      <Box
        minHeight="100vh"
        height="100%"
        overflow="auto"
        position="relative"
        maxHeight="100%"
        w="100%"
        maxWidth="100%"
      >
        {getRoute() ? (
          <Box mx="auto" minH="100vh" w="100%">
            <Routes>
              {getRoutes(routes)}
              <Route
                path="/"
                element={<Navigate to="/" replace />}
              />
            </Routes>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

